
class MessageQueue<T = unknown> {
    private processing: boolean;
    private queue: T[];
    private delay: number;
    private callback: (message: T | undefined) => void;

    constructor(delay: number, callback: (message: T | undefined) => void) {
        this.processing = false
        this.queue = []
        this.delay = delay
        this.callback = callback
    }

    addMessage(message: T) {
        this.queue.push(message)

        if (!this.processing) {
            this.processing = true
            this.processQueue()
        }
    }

    processQueue() {
        if (this.queue.length > 0) {
            const message = this.getNextMessage()

            this.callback(message)

            setTimeout(() => this.processQueue(), this.delay)
        } else {
            this.processing = false
            this.callback(undefined)
        }
    }

    getNextMessage() {
        return this.queue.shift();
    }
}

export default MessageQueue;
